import { isEmpty, isNil } from "../Helper";
export default class Modal {
    constructor(_root) {
        this.root = _root;
        this.triggers = Array.from(document.querySelectorAll(`[href="#${_root.id}"][data-toggle="modal"]`));
        this.closeButtons = Array.from(this.root.querySelectorAll('[data-dismiss="modal"]'));
        this.header = _root.querySelector(".neos-header");
        this.setupEventListeners();
    }
    setupEventListeners() {
        this.triggers.forEach((_trigger) => {
            _trigger.addEventListener("click", this.open.bind(this));
        });
        this.closeButtons.forEach((_closeButton) => {
            _closeButton.addEventListener("click", this.close.bind(this));
        });
        document.addEventListener("keyup", this.onKeyPress.bind(this));
    }
    open(_event) {
        _event.preventDefault();
        const targetElement = _event.target;
        const trigger = this.getTriggerElement(targetElement);
        this.handleDynamicHeader(trigger);
        this.root.classList.add("open");
        this.root.classList.remove("neos-hide");
        trigger.dispatchEvent(new CustomEvent("neoscms-modal-opened", {
            bubbles: true,
            detail: { identifier: this.root.id },
        }));
    }
    /**
     * Trigger buttons can contain icons or text and so the event target is maybe not the mapping
     * button element. So this function checks for the data-toggle attribute and if this does not
     * exists we try to find the closest matching element.
     *
     * @param {HTMLElement} _element
     * @return {HTMLElement}
     */
    getTriggerElement(_element) {
        if (isNil(_element)) {
            return null;
        }
        if (!_element.hasAttribute("data-toggle")) {
            _element = _element.closest('[data-toggle="modal"]');
        }
        return _element;
    }
    close() {
        this.root.classList.remove("open");
        this.root.classList.add("neos-hide");
        window.dispatchEvent(new CustomEvent("neoscms-modal-closed", {
            detail: { identifier: this.root.id },
        }));
    }
    onKeyPress(_event) {
        if (_event.key === "Escape") {
            this.close();
        }
    }
    handleDynamicHeader(_trigger) {
        if (isNil(_trigger) || isNil(this.header)) {
            return;
        }
        const dynamicHeader = _trigger.getAttribute("data-modal-header");
        if (!isEmpty(dynamicHeader)) {
            this.header.innerText = dynamicHeader;
        }
    }
}
